import React from 'react';

import styled from '@tanium/react-emotion-9';
import { css } from '@tanium/style-system';
import { ThemeSpace } from '@tanium/theme-data';

import { HeaderUnderline, SectionText } from './themeDefinitions';

export interface Props {
  /**
   * The title to display for the section.
   */
  title: React.ReactNode;

  /**
   * The size of the section.
   */
  size?: 'md' | 'lg';
  /**
   * The content of the section.
   */
  children?: React.ReactNode;
}

const Title = styled('h5', { shouldForwardProp: (p) => p !== 'size' })<Partial<Props>>(
  css({
    fontWeight: 'bold',
    pb: ThemeSpace.bordered[1],
    borderBottom: '1px solid',
    borderColor: HeaderUnderline,
    color: SectionText,
    m: 0,
    mb: 1,
  }),
  ({ size }) => ({
    fontSize: size === 'lg' ? 16 : 14,
  }),
);

const SectionBody = styled('div', { shouldForwardProp: (p) => p !== 'size' })<Partial<Props>>(
  { lineHeight: '20px' },
  ({ size }) =>
    css({
      fontSize: size === 'lg' ? '15px' : '14px',
      color: SectionText,
    }),
);

/**
 * A section with a header used within (or alongside) a SectionContainer.
 */
const SectionContainerSection = ({ title, size, children }: Props) => (
  <section>
    <Title size={size}>{title}</Title>
    <SectionBody size={size}>{children}</SectionBody>
  </section>
);

export default SectionContainerSection;
